export default __webpack_public_path__ + "static/media/default.60163f9278321526bd45740686180a23.png";